import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { TipoArquivoFilter } from '../filter';
import { TipoArquivoSearch, TipoArquivoSearchTotal } from '../tipo-arquivo-search';

@Injectable({
    providedIn: 'root'
})
export class TipoArquivoSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/tipos-arquivos`;
    }


    /** Realizada a pesquisa dos tipos de arquivos */
    search(filter: TipoArquivoFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<TipoArquivoSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<TipoArquivoSearch[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa dos tipos de arquivos */
    getTotais(filter: TipoArquivoFilter): Observable<TipoArquivoSearchTotal> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<TipoArquivoSearchTotal>(`${this.pathApi}/0/total`, {params});
    }
}
